import { render } from "./TachoRemoteFilesModal.vue?vue&type=template&id=6be141fc&ts=true"
import script from "./TachoRemoteFilesModal.vue?vue&type=script&lang=ts"
export * from "./TachoRemoteFilesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__